import { useMemo } from 'react'
import { isSalesOrderLineProductionRegionOverseas } from '@Orders/OrderDetailsPage/logic'
import { salesOrder_salesOrder_salesOrderLines_items as SalesOrderLinesItemsType } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrder'

export const useGetTotalOverseasAmount = (
    salesOrderLines: SalesOrderLinesItemsType[],
    isInternational?: boolean,
) =>
    useMemo(
        () =>
            (salesOrderLines || []).reduce((sum, salesOrderLine) => {
                if (
                    isSalesOrderLineProductionRegionOverseas(salesOrderLine) ||
                    isInternational
                ) {
                    return (
                        sum + salesOrderLine.quantity * salesOrderLine.unitPrice
                    )
                }
                return sum
            }, 0),
        [isInternational, salesOrderLines],
    )
